module.exports = __webpack_public_path__ + "img/bobuqo_bobocoin.gm.bd21603.png";